import { GET } from "services/httpService";
import { getAppConfig } from "services/configService";
import urlJoin from "url-join";

const apiUrl = () => {
  return getAppConfig().OrderApiUrl;
};

/*
There are 2 ways of referring to orders.
1 = SuperOrder -> Order -> OrderLines
OR
2 = Order -> Product -> CopyItem
We are converting the result form the API (1) to (2)
*/
const mapProduct = product => {
  return {
    ...product,
    orderCode: product.superOrderCode,
    superOrderCode: undefined
  };
};

const mapOrder = order => {
  return {
    ...order,
    products: order.orders.map(p => mapProduct(p)),
    productCount: order.orderCount,
    orderCount: undefined,
    orders: undefined
  };
};

export const getOrdersMe = async (requestInfo, orderState, offset = 0, limit = 10) => {
  const orders = await GET(
    requestInfo,
    urlJoin(apiUrl(), `/v2/superorders/me?offset=${offset}&limit=${limit}&state=${orderState}`)
  );

  return { ...orders, items: orders.items.map(o => mapOrder(o)) };
};

export const getOrderByCode = async (requestInfo, orderCode) => {
  const order = await GET(requestInfo, urlJoin(apiUrl(), `/v1/superorders/${orderCode}`));
  return mapOrder(order);
};
